import { useMemo, useState } from 'react';
import HkSlaConfig from './HkSlaConfig';
import HkChecklistMaster from './HkChecklistMaster';
import HkAmenityItems from './HkAmenityItems';
import HkAmenityTemplates from './HkAmenityTemplates';

/**
 * Housekeeping Configuration (Hotel Config → Housekeeping) — a dedicated
 * per-property housekeeping settings section for the hotel admin. Mirrors the
 * Engineering "Masters Hub" tab pattern (MaintMastersHub) so more housekeeping
 * config (SLA breach report, quality/turnaround rules, etc.) can slot in as tabs.
 *
 * Tab 1 — SLA Settings (ER-MOM-03): baseline room-turn minutes per room type.
 * Tab 2 — Checklist Master: admin-configurable per-task-type cleaning checklist.
 * Tabs 3-4 — Guest Amenity Inventory (Module 1): item master + per-room-type
 * consumption templates. Day-to-day stock movements (Purchase/Adjustment/
 * Balance) live under the Housekeeping menu's "Amenity Stock" screen instead,
 * since that's operational storekeeper work, not one-time admin config.
 */
function HkConfigHub({ token, selectedProperty }) {
  const tabs = useMemo(() => ([
    { key: 'sla', label: 'SLA Settings', render: () => <HkSlaConfig token={token} selectedProperty={selectedProperty} /> },
    { key: 'checklist', label: 'Checklist Master', render: () => <HkChecklistMaster token={token} selectedProperty={selectedProperty} /> },
    { key: 'amenity-items', label: 'Amenity Items', render: () => <HkAmenityItems token={token} selectedProperty={selectedProperty} /> },
    { key: 'amenity-templates', label: 'Amenity Templates', render: () => <HkAmenityTemplates token={token} selectedProperty={selectedProperty} /> },
  ]), [token, selectedProperty]);

  const [activeTab, setActiveTab] = useState('sla');
  const currentTab = tabs.find((t) => t.key === activeTab) || tabs[0];

  return (
    <div className="page-shell">
      <div style={{ marginBottom: '0.2rem', color: 'var(--theme-text-secondary)', fontSize: '0.82rem' }}>Hotel Config &gt; Housekeeping</div>
      <h2 style={{ color: 'var(--theme-primary)', margin: '0 0 0.75rem' }}>Housekeeping Configuration</h2>
      <div style={{ display: 'flex', gap: '0.45rem', flexWrap: 'wrap', borderBottom: '1px solid #dcdde1', paddingBottom: '0.55rem', marginBottom: '0.8rem' }}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              padding: '0.42rem 0.8rem',
              borderRadius: '6px',
              border: '1px solid #dcdde1',
              cursor: 'pointer',
              background: tab.key === currentTab.key ? 'var(--theme-accent)' : '#fff',
              color: tab.key === currentTab.key ? '#fff' : 'var(--theme-primary)',
              fontWeight: 700
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{currentTab.render()}</div>
    </div>
  );
}

export default HkConfigHub;
